import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { SharedConstants } from '../models/shared/shared.constants';
@Injectable({
  providedIn: 'root'
})
export class StorageAplicationService {

  private readonly SECRET_KEY: string;
  constructor(private readonly constants: SharedConstants) {
    this.SECRET_KEY = this.constants.getApiSecretKey();
  }

  public getDataSesionStorage(name: string) {
    if (sessionStorage.getItem(name)) {
      let data = sessionStorage.getItem(name);
      return this.dataDecoder(JSON.stringify(data));
    } else {
      return null;
    }
  }

  public getDataLocalStorage(name: string) {
    if (localStorage.getItem(name)) {
      let data = localStorage.getItem(name);
      return this.dataDecoder(JSON.stringify(data));
    } else {
      return null;
    }
  }

  public setDataSesionStorage(name: string, data: string) {
    let dataCoder = this.dataCoder(data);
    sessionStorage.setItem(name, dataCoder);
  }

  public setDataLocalStorage(name: string, data: string) {
    let dataCoder = this.dataCoder(data);
    localStorage.setItem(name, dataCoder);
  }

  public cleanStorage() {
    sessionStorage.clear();
    localStorage.clear();
  }

  private dataCoder(data: string): string {
    let response = CryptoJS.AES.encrypt(data, this.SECRET_KEY);
    return response.toString();
  }

  private dataDecoder(data: string): string {
    let response = CryptoJS.AES.decrypt(data, this.SECRET_KEY);
    return response.toString(CryptoJS.enc.Utf8);
  }
}
